<template>
  <div class="h-auto ml-0 w-full lg:mr-3 mt-2 p-3 pt-0">
    <el-tabs type="border-card">
      <el-tab-pane
        v-for="(tab, index) in tabs"
        :key="index"
        :label="tab.name"
        @click="(e) => setTab(e, tab.name)"
      >
        <BenefitsList v-if="index == 0"></BenefitsList>
        <BenefitGroupsList v-if="index == 1"></BenefitGroupsList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// Other setups
import BenefitsList from "@/components/CompanySetups/benefitsSetups/benefitsList.vue";
import BenefitGroupsList from "@/components/CompanySetups/benefitsSetups/benefitGroupsList.vue";

export default {
  name: "SetupsTabs",
  props: ["updateLeaveList", "setup"],
  components: {
    BenefitsList,
    BenefitGroupsList,
  },
  data() {
    return {
      selectedTab: "Benefits",
      teamKey: 0,
      mineKey: 1,
      isApproved: true,
      isDeclined: false,
      tabs: [
        {
          name: "Benefits",
          route: "benefits",
        },
        {
          name: "Benefit Groups",
          route: "benefits-groups",
        },
      ],
    };
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
  watch: {},
};
</script>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
</style>
